module.exports = __webpack_public_path__ + "static/img/1.4808489.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/center/1.png
// module id = 6oym
// module chunks = 0